angular.module('iw.frontyard.repayment_calculator')
    .service('calculateTablePadding', function() {
        function calculateTablePadding(duration){
            if(duration > 8){
                return true;
            }
            else{
                return false
            }
        }
        return calculateTablePadding;
    });